// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ADD_NEXT_PHOTO = "Pridaj fotku";
